module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch5_20210921021151_T.2ce92e66.jpg";